import { useState } from "react";
import { useDebounce } from "use-debounce";
import { SpinnerLegacy } from "../../../components";
import { Alert } from "../../../components/alert/Alert";
import { InfiniteList } from "../../../components/infiniteLoading/InfiniteList";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useBuyerRelationshipList } from "../../../hooks/api/v2/buyerRelationship/useBuyerRelationshipList";
import { NewConnectionCommentLink } from "./NewConnectionCommentLink";
import { NewConnectionConnectionDialogSearchInput } from "./NewConnectionConnectionDialogSearchInput";

export const BuyerNewConnectionCommentThreadDialogContent = ({
  setDialogActive,
}: {
  setDialogActive: (active: boolean) => void;
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue] = useDebounce(searchValue, 500);

  const buyerRelationshipListQuery = useBuyerRelationshipList({
    query: [
      {
        type: "connectionType",
        modifier: "EQUALS",
        value: "customer",
      },
    ],
    limit: 10,
    search: debouncedSearchValue,
  });

  return (
    <div>
      {buyerRelationshipListQuery.isError ? (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(buyerRelationshipListQuery.error)?.response?.data
              .message ?? "Unknown error"
          }
        />
      ) : (
        <InfiniteList query={buyerRelationshipListQuery}>
          <NewConnectionConnectionDialogSearchInput
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
          {buyerRelationshipListQuery.isLoading ? (
            <SpinnerLegacy />
          ) : (
            buyerRelationshipListQuery.data?.pages.map((page) =>
              page.map((buyerRelationship) => (
                <NewConnectionCommentLink
                  key={buyerRelationship.id}
                  relationshipId={buyerRelationship.RelationshipId}
                  setActive={setDialogActive}
                  business={buyerRelationship.Relationship.Supplier.Business}
                />
              )),
            )
          )}
        </InfiniteList>
      )}
    </div>
  );
};
